// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testSessionId } from './TestSession';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testSessionEventId = (z.string());
export const testSessionEvent = z.object({
    id: testSessionEventId,
    test_session_id: testSessionId,
    kind: z.string(),
    payload: z.unknown(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const testSessionEventInitializer = z.object({
    id: testSessionEventId.optional(),
    test_session_id: testSessionId,
    kind: z.string(),
    payload: z.unknown().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const testSessionEventMutator = z.object({
    id: testSessionEventId.optional(),
    test_session_id: testSessionId.optional(),
    kind: z.string().optional(),
    payload: z.unknown().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=TestSessionEvent.js.map